import { render, staticRenderFns } from "./ValueAccount.vue?vue&type=template&id=33b08992&"
import script from "./ValueAccount.vue?vue&type=script&lang=js&"
export * from "./ValueAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports